/**
 * @type {{add_user: string}}
 */
export const uiActions = {
  toggleSelectBase: "toggle_select_base",
  toggleSettings: "toggle_settings",
  toggleSelectLeader: "toggle_select_leader",
  togglePickWinnerModal: "toggle_winner_modal",
  toggleLog: "toggle_log",
  toggleInitiativeModal: "toggle_initiative_modal",
};

/**
 * @name toggleSelectBaseReducer
 * @param {SwucState} state
 * @param {StateUiToggle} payload
 * @return {SwucState}
 */
function toggleSelectBaseReducer(state, { player = "none", show = false }) {
  const newState = { ...state };
  newState.ui.showBaseModal = { player, show };
  return newState;
}

/**
 * @name toggleSettingsReducer
 * @param {SwucState} state
 * @param {StateUiToggle} payload
 * @return {SwucState}
 */
function toggleSettingsReducer(state, { player = "none", show = false }) {
  const newState = { ...state };
  newState.ui.showSettings = { player, show };
  return newState;
}

/**
 * @name toggleLogReducer
 * @param {SwucState} state
 * @param {StateUiToggle} payload
 * @return {SwucState}
 */
function toggleLogReducer(state, { player, show }) {
  const newState = { ...state };
  newState.ui.showLog = { player, show };
  return newState;
}

/**
 * @name toggleInitiativeReducer
 * @param {SwucState} state
 * @param {StateUiToggle} payload
 * @return {SwucState}
 */
export function toggleInitiativeReducer(state, { player, show }) {
  const newState = { ...state };
  newState.ui.showInitiative = { player: "bottom", show };
  return newState;
}

/**
 *  @name toggleSelectLeaderReducer
 * @param {SwucState} state
 * @param {StateUiToggle} payload
 * @return {SwucState}
 */
function toggleSelectLeaderReducer(state, { player = "none", show = false }) {
  const newState = { ...state };
  newState.ui.showLeaderModal = { player, show };
  return newState;
}
/**
 *  @name toggleSelectLeaderReducer
 * @param {SwucState} state
 * @param {StateUiToggle} payload
 * @return {SwucState}
 */
function togglePickWinnerModalReducer(
  state,
  { player = "none", show = false }
) {
  const newState = { ...state };
  newState.ui.showPickWinnerModal = { player, show };
  return newState;
}

/**
 * @type {{string: function(SwucState, string=): SwucState}}
 */
export const UiReducers = {
  [uiActions.toggleSelectBase]: toggleSelectBaseReducer,
  [uiActions.toggleSettings]: toggleSettingsReducer,
  [uiActions.toggleSelectLeader]: toggleSelectLeaderReducer,
  [uiActions.togglePickWinnerModal]: togglePickWinnerModalReducer,
  [uiActions.toggleLog]: toggleLogReducer,
  [uiActions.toggleInitiativeModal]: toggleInitiativeReducer,
};
